"use strict";
import { Vector } from 'three-csg-ts/lib/esm/Vector';
import { Renderer } from './lib/Renderer';
import { Lights } from './lib/Lights';
import { tween } from './lib/TWEEN';
import { Scene } from './lib/Scene';
import { Env } from './lib/Env';
import * as THREE from 'three';
import { ID } from './lib/ID';

export class Form {

    accessoriesID: number;
    grupaID: number;
    depth: number;
    shapes: any[];
    ID: number;
    data: any;

    drills = (function () {
        let drillsGroup: any[] = [];
        for (let i = 0; i < 6; i++) {
            const group = new THREE.Group();
            group.name = `drillGroup${i}`;
            drillsGroup.push(group);
        }
        return drillsGroup;
    })();

    constructor(data: any) {
        this.data = data;
        this.depth = 0.1 * Env.size_units;

        this.constShapes();
        if(!Env.cabinets_cart_data){
            if (this.data.size && this.data.drill) {
                if (this.data.shapes === undefined) {
                    try {
                        this.holes_and_drill();
                    } catch(e) {}
                }
            }
        }
        // this.showThisVariablesValue();//TODO: REMOVE ME
    }

    showThisVariablesValue() { //TODO: REMOVE ME
        Object.keys(this).map((key) => {
            console.debug(`klucz ${key}: `, this[key]);
        })
    }

    constShapes() {
        if (this.data.shapes !== undefined) {
            let x = { min: 10000, max: -10000 }, y = { min: 10000, max: -10000 };

            for (let index in this.data.shapes) {
                x.min = this.data.shapes[index].x < x.min ? parseFloat(this.data.shapes[index].x) : x.min;
                x.max = this.data.shapes[index].x > x.max ? parseFloat(this.data.shapes[index].x) : x.max;
                y.min = this.data.shapes[index].y < y.min ? parseFloat(this.data.shapes[index].y) : y.min;
                y.max = this.data.shapes[index].y > y.max ? parseFloat(this.data.shapes[index].y) : y.max;
            }

            for (let index in this.data.shapes) {
                this.data.shapes[index].x -= (x.max - x.min) / 2;
                this.data.shapes[index].y -= (y.max - y.min) / 2;
            }
            this.shapes = [
                new THREE.Shape(this.data.shapes),
                new THREE.Shape(this.data.shapes),
            ]
            for (let index in this.data.shapes) {
                const indexUp = parseInt(index) <= this.data.shapes.length - 2 ? parseInt(index) + 1 : 0;
                this.shapes.push(
                    new THREE.Shape(
                        [
                            this.data.shapes[index],
                            this.data.shapes[indexUp]
                        ]
                    )
                );
            }
        } else {
            if (this.data.size !== undefined) {
                this.shapes = [
                    new THREE.Shape([ //material_front //green
                        new THREE.Vector2(-this.data.size.x / 2, -this.data.size.y / 2),
                        new THREE.Vector2(this.data.size.x / 2, -this.data.size.y / 2),
                        new THREE.Vector2(this.data.size.x / 2, this.data.size.y / 2),
                        new THREE.Vector2(-this.data.size.x / 2, this.data.size.y / 2)
                    ]),
                    new THREE.Shape([ //material_back //red
                        new THREE.Vector2(-this.data.size.x / 2, -this.data.size.y / 2),
                        new THREE.Vector2(this.data.size.x / 2, -this.data.size.y / 2),
                        new THREE.Vector2(this.data.size.x / 2, this.data.size.y / 2),
                        new THREE.Vector2(-this.data.size.x / 2, this.data.size.y / 2)
                    ]),
                    new THREE.Shape([ //veneer_right //yellow
                        new THREE.Vector2(-this.data.size.x / 2, this.data.size.z / 2 - this.depth),
                        new THREE.Vector2(this.data.size.x / 2, this.data.size.z / 2 - this.depth),
                        new THREE.Vector2(this.data.size.x / 2, -this.data.size.z / 2 + this.depth),
                        new THREE.Vector2(-this.data.size.x / 2, -this.data.size.z / 2 + this.depth)
                    ]),
                    new THREE.Shape([ //veneer_left //black
                        new THREE.Vector2(-this.data.size.x / 2, this.data.size.z / 2 - this.depth),
                        new THREE.Vector2(this.data.size.x / 2, this.data.size.z / 2 - this.depth),
                        new THREE.Vector2(this.data.size.x / 2, -this.data.size.z / 2 + this.depth),
                        new THREE.Vector2(-this.data.size.x / 2, -this.data.size.z / 2 + this.depth)
                    ]),
                    new THREE.Shape([ //veneer_bottom //#9b9b9b
                        new THREE.Vector2(-this.data.size.y / 2, this.data.size.z / 2 - this.depth),
                        new THREE.Vector2(this.data.size.y / 2, this.data.size.z / 2 - this.depth),
                        new THREE.Vector2(this.data.size.y / 2, -this.data.size.z / 2 + this.depth),
                        new THREE.Vector2(-this.data.size.y / 2, -this.data.size.z / 2 + this.depth)
                    ]),
                    new THREE.Shape([ //veneer_top //blue
                        new THREE.Vector2(-this.data.size.y / 2, this.data.size.z / 2 - this.depth),
                        new THREE.Vector2(this.data.size.y / 2, this.data.size.z / 2 - this.depth),
                        new THREE.Vector2(this.data.size.y / 2, -this.data.size.z / 2 + this.depth),
                        new THREE.Vector2(-this.data.size.y / 2, -this.data.size.z / 2 + this.depth)
                    ])
                ];
            }
        }
        return this;
    }

    holes_and_drill() {
        const context = this;
        if (this.data.drill !== undefined) {
            for (const currentDrill of this.data.drill) {
                const typ = currentDrill.type;
                if( !currentDrill.diameter ) { const message = 'Wartość diameter nie może wynosić: 0'; console.debug(message); throw message; }
                if( !currentDrill.depth ) { const message = 'Wartość depth nie może wynosić: 0'; console.debug(message); throw message; }
                const diameter = currentDrill.diameter / 2 * Env.size_units;
                const depth = currentDrill.depth * Env.size_units;
                let index = ('face' in currentDrill && currentDrill.face === 'back') ? 1 : 0;
                currentDrill.start_axis_x = index === 1
                    ? currentDrill.start_axis_x === 'left' ? 'right' : 'left'
                    : currentDrill.start_axis_x;
                currentDrill.edge = index === 1
                    ? currentDrill.edge === 'left' ? 'right' : (currentDrill.edge === 'right' ? 'left' : currentDrill.edge)
                    : currentDrill.edge;
                if (currentDrill.face_type.includes('edge')) {
                    const edge_shapes = {
                        front: { number: 0 },
                        back: { number: 1 },
                        right: { number: 2, factor: { top: 1, bottom: -1 } },
                        left: { number: 3, factor: { top: 1, bottom: -1 } },
                        bottom: { number: 4, factor: { left: 1, right: -1 } },
                        top: { number: 5, factor: { left: 1, right: -1 } }
                    };
                    const position = currentDrill[`move_${currentDrill.axis}`] * Env.size_units;
                    let x = edge_shapes[currentDrill.edge].factor[currentDrill[`start_axis_${currentDrill.axis}`]] * (this.data.size[currentDrill.axis === 'x' ? 'y' : 'x'] / 2) + position * -edge_shapes[currentDrill.edge].factor[currentDrill[`start_axis_${currentDrill.axis}`]];
                    let y = 0;
                    drill(this, x, y, diameter, depth, edge_shapes[currentDrill.edge].number);
                } else {
                    let y = currentDrill.move_x * Env.size_units;
                    let x = currentDrill.move_y * Env.size_units;
                    // const horizontalSide = index === 0 ? 'top' : 'bottom';
                    // const verticalSide = index === 0 ? 'left' : 'right';
                    x = currentDrill.start_axis_y === 'top' ? this.data.size.x / 2 - x : -this.data.size.x / 2 + x;
                    y = currentDrill.start_axis_x === 'left' ? this.data.size.y / 2 - y : -this.data.size.y / 2 + y;
                    const shift = parseFloat(currentDrill.move_distance) * Env.size_units;
                    if ('qty_drills' in currentDrill) {
                        for (let i = parseInt(currentDrill.qty_drills); i >= 1; i--) {
                            if (i < currentDrill.qty_drills) {
                                x = currentDrill.move_angle == 0 || currentDrill.move_angle == 180
                                    ? ((currentDrill.start_axis_y === 'bottom' && index === 0) || (currentDrill.start_axis_y === 'top' && index !== 0)
                                        ? x + shift
                                        : ((currentDrill.start_axis_y === 'bottom' && index !== 0) || currentDrill.start_axis_y === 'top' && index === 0)
                                            ? x - shift
                                            : x
                                    )
                                    : x;
                                y = currentDrill.move_angle == 90 || currentDrill.move_angle == 270
                                    ? (currentDrill.start_axis_x === 'right'
                                        ? y + shift
                                        : (currentDrill.start_axis_x === 'left' ? y - shift : y))
                                    : y;
                            }
                            drill(this, x, y, diameter, depth, index);
                        }
                    }
                    if (typ === 'dowel' || typ === 'confirmat' || (typ.includes('drill') && !typ.includes('group')) || typ.includes('mark')) {
                        drill(this, x, y, diameter, depth, index);
                    }
                }
            }
        }
        return this;

        function drill(context:any, x:number, y:number, diameter:number, depth:number, index:number) {
            context.shapes[index].holes.push(new THREE.Path().absarc(x, y, diameter, 0, Math.PI * 2, true));
            if (index === 0 || index === 1) {
                if (depth >= context.data.size.z) {
                    context.shapes[index === 1 ? 0 : 1].holes.push(new THREE.Path().absarc(x, y, diameter, 0, Math.PI * 2, true));
                    let drill = visualization(diameter, context.data.size.z, true, (index === 1));
                    drill.position.set(x, y, 0);
                    context.drills[index].add(drill);
                } else { 
                    let drill = visualization(diameter, depth, false, (index === 1));
                    drill.position.set(x, y, 0);
                    context.drills[index].add(drill);
                }
            } else {
                let drill_veneer_left = visualization(diameter, depth, false, (index === 4 || index === 3));
                drill_veneer_left.position.x = x;
                context.drills[index].add(drill_veneer_left);
            }
        }

        function visualization(radius, height, closure = false, reverse = false) {
            const drillGroup = new THREE.Group();
            Scene.scene.add(drillGroup);
            //cylinder
            const radiusTop = radius;
            const radiusBottom = radius;
            let cylinderGeometry = Env.geometryLibrary.find(geometry => geometry.parameters.radiusTop === radiusTop && geometry.parameters.radiusBottom === radiusBottom && geometry.parameters.height === height);
            if (!cylinderGeometry) {
                cylinderGeometry = new THREE.CylinderGeometry(radius, radius, height, 64, 1, true);
                Env.geometryLibrary.push(cylinderGeometry);
            }
            const cylinderMaterialMapURL = `${Env.base_url}static/corps/obrzeze_brak.jpg`;
            const repeat = new THREE.Vector2(.2, .2);
            let cylinderMaterial = Env.materialsLibrary.find((material:THREE.MeshBasicMaterial) => material.userData.url === cylinderMaterialMapURL && material.userData.textureRepeatX === repeat.x && material.userData.textureRepeatY === repeat.y) ?? new THREE.MeshBasicMaterial({
                    side: THREE.DoubleSide,
                    userData: {
                        url: cylinderMaterialMapURL,
                        textureRepeatX: repeat.x,
                        textureRepeatY: repeat.y,
                    },
                    map: context.setTexture('', cylinderMaterialMapURL, repeat)
                });
                Env.materialsLibrary.push(cylinderMaterial);
            
            const cylinderMesh = new THREE.InstancedMesh(cylinderGeometry, cylinderMaterial, 1);
            ID.materials.push(cylinderMaterial.id);
            ID.geometry.push(cylinderGeometry.id);
            ID.meshs.push(cylinderMesh.id);
            cylinderMesh.castShadow = true;
            cylinderMesh.receiveShadow = true;
            drillGroup.add(cylinderMesh);
            cylinderMesh.rotation.x = Math.PI / 2;
            if (!reverse) {
                cylinderMesh.position.z = -height / 2;
            } else {
                cylinderMesh.position.z = height / 2;
            }
            //circle
            if (!closure) {
                let circleGeometry;
                if (Env.geometryLibrary.find(geometry => geometry.parameters.radius === radius)) {
                    circleGeometry = Env.geometryLibrary.find(geometry => geometry.parameters.radius === radius);
                } else {
                    circleGeometry = new THREE.CircleGeometry(radius, 128);
                    Env.geometryLibrary.push(circleGeometry);
                }
                const circleMaterialMapURL = `${Env.base_url}static/corps/obrzeze_brak.jpg`;
                const repeat = new THREE.Vector2(.2, .2);
                let circleMaterial = Env.materialsLibrary.find(material => material.userData.url === circleMaterialMapURL && material.userData.textureRepeatX === repeat.x && material.userData.textureRepeatY === repeat.y);
                if (!circleMaterial) {
                    circleMaterial = new THREE.MeshBasicMaterial({
                        side: THREE.DoubleSide,
                        userData: {
                            url: circleMaterialMapURL,
                            textureRepeatX: repeat.x,
                            textureRepeatY: repeat.y,
                        },
                        map: context.setTexture('', circleMaterialMapURL, repeat)
                    });
                    Env.materialsLibrary.push(circleMaterial);
                }
                const circleMesh = new THREE.InstancedMesh(circleGeometry, circleMaterial, 1);
                ID.materials.push(circleMaterial.id);
                ID.geometry.push(circleGeometry.id);
                ID.meshs.push(circleMesh.id);
                circleMesh.receiveShadow = true;
                circleMesh.castShadow = true;
                drillGroup.add(circleMesh);
                if (!reverse) {
                    circleMesh.position.z = -height;
                } else {
                    circleMesh.position.z = height;
                }
            }
            return drillGroup;
        }
    }

    create() {
        if (!Object.keys(this.data).length) {
            throw 'brak danych';
        }

        const extrudeSettings = { depth: this.depth, steps: 10, bevelEnabled: true, bevelThickness: .5 * Env.size_units, bevelSize: .5 * Env.size_units, bevelOffset: 0, bevelSegments: 10 };

        const cube = new THREE.Group();
        cube.name = this.data.key;
        const grupa = new THREE.Group();
        grupa.name = 'grupa';
        this.grupaID = grupa.id;
        const accessories = new THREE.Group();
        accessories.name = 'accessories';
        this.accessoriesID = accessories.id;
        let edges = new THREE.Group();
        edges.name = 'edges';

        if (this.data.shapes !== undefined) {
            edges = new THREE.Group();
            edges.name = 'edges';
            const geometry_front = new THREE.ExtrudeGeometry(this.shapes[0], extrudeSettings);
            ID.geometry.push(geometry_front.id);
            const material_front = new THREE.InstancedMesh(
                geometry_front,
                this.setMaterial('material_front', 0x38ff20),
                1
            );
            ID.meshs.push(material_front.id);
            material_front.position.z += this.data.size.z / 2;
            edges.add(material_front);

            const geometry_back = new THREE.ExtrudeGeometry(this.shapes[0], extrudeSettings);
            ID.geometry.push(geometry_back.id);
            const material_back = new THREE.InstancedMesh(
                geometry_back,
                this.setMaterial('material_back', 0xff0000),
                1
            );
            ID.meshs.push(material_back.id);
            material_back.position.z -= this.data.size.z / 2;
            edges.add(material_back);

            extrudeSettings.depth = this.data.size.z;
            for (let i = 2; i < this.shapes.length; i++) {
                // console.debug(parseFloat(this.shapes[i].curves[0]['v1'].x / Env.size_units), this.shapes[i].curves[0]['v1'].y / Env.size_units)
                // console.debug(this.shapes[i].curves[0]['v2'].x / Env.size_units, this.shapes[i].curves[0]['v2'].y / Env.size_units)
                const geometry_veneer = new THREE.ExtrudeGeometry(this.shapes[i], extrudeSettings);
                ID.geometry.push(geometry_veneer);
                const veneer = new THREE.InstancedMesh(
                    geometry_veneer,
                    this.setMaterial(`veneer_#${i - 2}`, 0x008dff),
                    1
                );
                ID.meshs.push(veneer.id);
                veneer.position.z -= this.data.size.z / 2;
                veneer.castShadow = true;
                veneer.receiveShadow = true;
                // veneer.material.map.anisotropy = renderer.capabilities.getMaxAnisotropy();
                edges.add(veneer);
            }
        } else {
            if (this.data.size !== undefined) {

                /*             ____/grey/________
                              / veneerBottom   /|          ^ +              |
                             /________________/ |          |                |
                             |                | |          |                |
                             |                | |          |                |
                    venner   |                | |  venner  |                |
                    Right    |   PLANE        | |  Left    |                |
                    /yellow/ |   Face FRONT   | | /black/  | y /szerokość   | y (z eRozrysu)
                             |                | |          |                |
                             |   /Green/      | /          |                |
                             |________________|/           |                |
                                 veneerTop                 |                |
                                   /blue/                  |                |
                                                           |                |
                    -                x                +    | -              v
                    ---------------------------------->
                                 długość

                                x (z eRozrysu)
                    <---------------------------------
                */

                // const evaluator = new Evaluator();

                // edges = new Brush(new THREE.BoxGeometry(this.data.size.x, this.data.size.y, this.data.size.z), this.setMaterial('', '#38ff20'));

                // const front = new Brush(new THREE.BoxGeometry(this.data.size.x, this.data.size.y, .1 * Env.size_units), this.setMaterial('material_front', '#38ff20'));
                // front.position.z = this.data.size.z / 2;
                // front.updateMatrixWorld();
                // edges = evaluator.evaluate(edges, front, ADDITION);

                // const back = new Brush(new THREE.BoxGeometry(this.data.size.x, this.data.size.y, .1 * Env.size_units), this.setMaterial('material_back', 'red'));
                // back.position.z = -this.data.size.z / 2;
                // back.updateMatrixWorld();
                // edges = evaluator.evaluate(edges, back, ADDITION);

                // const veneerTop = new Brush(new THREE.BoxGeometry(this.data.size.x, this.data.size.z, .1 * Env.size_units), this.setMaterial((this.data.graining === 1 ? 'veneer_top' : 'veneer_right'), (this.data.graining === 1 ? '#008dff' : 'yellow')));
                // veneerTop.position.y = -this.data.size.y / 2;
                // veneerTop.rotation.x = Math.PI / 2;
                // veneerTop.updateMatrixWorld();
                // edges = evaluator.evaluate(edges, veneerTop, ADDITION);

                // const veneerBottom = new Brush(new THREE.BoxGeometry(this.data.size.x, this.data.size.z, .1 * Env.size_units), this.setMaterial((this.data.graining === 1 ? 'veneer_bottom' : 'veneer_left'), (this.data.graining === 1 ? '#9b9b9b' : 'black')));
                // veneerBottom.position.y = this.data.size.y / 2;
                // veneerBottom.rotation.x = -Math.PI / 2;
                // veneerBottom.updateMatrixWorld();
                // edges = evaluator.evaluate(edges, veneerBottom, ADDITION);

                // const veneerRight = new Brush(new THREE.BoxGeometry(this.data.size.y, this.data.size.z, .1 * Env.size_units), this.setMaterial((this.data.graining === 1 ? 'veneer_right' : 'veneer_bottom'), (this.data.graining === 1 ? 'yellow' : '#9b9b9b')));
                // veneerRight.position.x = -this.data.size.x / 2;
                // veneerRight.rotation.z = Math.PI / 2;
                // veneerRight.rotation.y = Math.PI / 2;
                // veneerRight.updateMatrixWorld();
                // edges = evaluator.evaluate(edges, veneerRight, ADDITION);

                // const veneerLeft = new Brush(new THREE.BoxGeometry(this.data.size.y, this.data.size.z, .1 * Env.size_units), this.setMaterial((this.data.graining === 1 ? 'veneer_left' : 'veneer_top'), (this.data.graining === 1 ? 'black' : '#008dff')));
                // veneerLeft.position.x = this.data.size.x / 2;
                // veneerLeft.rotation.z = Math.PI / 2;
                // veneerLeft.rotation.y = Math.PI / 2;
                // veneerLeft.updateMatrixWorld();
                // edges = evaluator.evaluate(edges, veneerLeft, ADDITION);

                // if (this.data.drill) {
                //     for (const drill of this.data.drill) {
                //         if (drill.face === 'back') {
                //             if (drill.face && drill.face === 'back') {
                //                 const parameters = ['start_axis_x', 'start_axis_y', 'edge'];
                //                 for (let name of parameters) {
                //                     drill[name] = drill[name] === 'right'
                //                         ? 'left'
                //                         : (drill[name] === 'left'
                //                             ? 'right'
                //                             : drill[name]);
                //                 }
                //             }
                //         }
                //         const cylinderGeometry = new THREE.CylinderGeometry(drill.diameter / 2 * Env.size_units, drill.diameter / 2 * Env.size_units, drill.depth * Env.size_units + .2 * Env.size_units, 64, 1, false);
                //         const cylinderMesh = new Brush(
                //             cylinderGeometry,
                //             this.setMaterial('', '#ff00ff')
                //         );
                //         switch (drill.face_type) {
                //             case 'plain': {
                //                 let index = ('face' in drill && drill.face === 'back') ? 1 : 0;
                //                 drill.start_axis_x = index === 1
                //                     ? drill.start_axis_x === 'left' ? 'right' : 'left'
                //                     : drill.start_axis_x;
                //                 drill.edge = index === 1
                //                     ? drill.edge === 'left' ? 'right' : (drill.edge === 'right' ? 'left' : drill.edge)
                //                     : drill.edge;
                //                 let y = drill.move_x * Env.size_units;
                //                 let x = drill.move_y * Env.size_units;
                //                 x = drill.start_axis_y === 'top' ? this.data.size.x / 2 - x : -this.data.size.x / 2 + x;
                //                 y = drill.start_axis_x === 'left' ? this.data.size.y / 2 - y : -this.data.size.y / 2 + y;
                //                 const z = drill.face && drill.face === 'back'
                //                     ? (-this.data.size.z / 2) + ((drill.depth * Env.size_units) / 2)
                //                     : (this.data.size.z / 2) - ((drill.depth * Env.size_units) / 2);
                //                 cylinderMesh.rotation.x = Math.PI / 2;
                //                 if (drill.qty_drills) {
                //                     const shift = parseFloat(drill.move_distance) * parseFloat(Env.size_units);
                //                     for (let i = parseInt(drill.qty_drills); i >= 1; i--) {
                //                         if (i < drill.qty_drills) {
                //                             switch (drill.move_angle) {
                //                                 case 0:
                //                                     if ((drill.start_axis_y === 'bottom' && index === 0)
                //                                         || (drill.start_axis_y === 'top' && index !== 0)) {
                //                                         x = x + shift;
                //                                     } else if ((drill.start_axis_y === 'bottom' && index !== 0)
                //                                         || (drill.start_axis_y === 'top' && index === 0)) {
                //                                         x = x - shift;
                //                                     }
                //                                     break;
                //                                 case 90:
                //                                     if (drill.start_axis_x === 'right') {
                //                                         y = y + shift;
                //                                     } else if (drill.start_axis_x === 'left') {
                //                                         y = y - shift;
                //                                     }
                //                                     break;
                //                                 case 180:
                //                                     if ((drill.start_axis_y === 'bottom' && index === 0)
                //                                         || (drill.start_axis_y === 'top' && index !== 0)) {
                //                                         x = x - shift;
                //                                     } else if ((drill.start_axis_y === 'bottom' && index !== 0)
                //                                         || (drill.start_axis_y === 'top' && index === 0)) {
                //                                         x = x + shift;
                //                                     }
                //                                     break;
                //                                 case 270:
                //                                     if (drill.start_axis_x === 'right') {
                //                                         y = y - shift;
                //                                     } else if (drill.start_axis_x === 'left') {
                //                                         y = y + shift;
                //                                     }
                //                                     break;
                //                             }
                //                             cylinderMesh.position.set(x, y, z);
                //                             cylinderMesh.updateMatrixWorld();
                //                             edges = evaluator.evaluate(edges, cylinderMesh, SUBTRACTION);
                //                         }
                //                     }
                //                 } else {
                //                     cylinderMesh.position.set(x, y, z);
                //                     cylinderMesh.updateMatrixWorld();
                //                     edges = evaluator.evaluate(edges, cylinderMesh, SUBTRACTION);
                //                 }
                //             }
                //                 break;
                //             case 'edge':
                //                 let x, y, z;
                //                 switch (drill.edge) {
                //                     case 'left':
                //                         x = drill.start_axis_y === 'top' ? this.data.size.x / 2 - drill.move_y*Env.size_units : -this.data.size.x / 2 + drill.move_y*Env.size_units;
                //                         y = this.data.size.y / 2 - drill.depth * Env.size_units / 2;
                //                         z = -this.data.size.z / 2 + drill.move_x*Env.size_units;
                //                         break;
                //                     case 'right':
                //                         // cylinderMesh.rotation.z = Math.PI / 2;
                //                         x = drill.start_axis_y === 'top' ? this.data.size.x / 2 - drill.move_y*Env.size_units : -this.data.size.x / 2 + drill.move_y*Env.size_units;
                //                         y = -this.data.size.y / 2 + drill.depth * Env.size_units / 2;
                //                         z = -this.data.size.z / 2 + drill.move_x*Env.size_units;
                //                         break;
                //                     // case 'bottom':
                //                     //     x = drill.start_axis_x === 'right' ? -this.data.size.x / 2 + drill.move_x*Env.size_units : this.data.size.x / 2 - drill.move_x*Env.size_units;
                //                     //     y = this.data.size.y / 2 - drill.depth * Env.size_units / 2;
                //                     //     z = -this.data.size.z / 2 + drill.move_y*Env.size_units;
                //                     //     break;
                //                     // case 'top':
                //                     //     x = drill.start_axis_x === 'right' ? -this.data.size.x / 2 + drill.move_x*Env.size_units : this.data.size.x / 2 - drill.move_x*Env.size_units;
                //                     //     y = this.data.size.y / 2 - drill.depth * Env.size_units / 2;
                //                     //     z = -this.data.size.z / 2 + drill.move_y*Env.size_units;
                //                     //     break;
                //                 }
                //                 cylinderMesh.position.set(x, y, z);
                //                 cylinderMesh.updateMatrixWorld();
                //                 edges = evaluator.evaluate(edges, cylinderMesh, SUBTRACTION);
                //                 // Scene.scene.add(cylinderMesh)
                //                 // console.log(this.data.key, drill)
                //                 // console.log('################')
                //                 // console.log(x)
                //                 // const edge_shapes = {
                //                 //     front: { number: 0 },
                //                 //     back: { number: 1 },
                //                 //     right: { number: 2, factor: { top: 1, bottom: -1 } },
                //                 //     left: { number: 3, factor: { top: 1, bottom: -1 } },
                //                 //     bottom: { number: 4, factor: { left: 1, right: -1 } },
                //                 //     top: { number: 5, factor: { left: 1, right: -1 } }
                //                 // };
                //                 // const position = drill[`move_${drill.axis}`] * Env.size_units;
                //                 // x = edge_shapes[drill.edge].factor[drill[`start_axis_${drill.axis}`]] * (this.data.size[drill.axis === 'x' ? 'y' : 'x'] / 2) + position * -edge_shapes[drill.edge].factor[drill[`start_axis_${drill.axis}`]];
                //                 // // let y = 0;
                //                 // console.log(x)
                //                 break;
                //         }
                //     }
                // }


                /** PLASZCZYZNA */
                const side0_geometry = new THREE.ExtrudeGeometry(this.shapes[0], extrudeSettings);
                ID.geometry.push(side0_geometry.id);
                const side0 = new THREE.InstancedMesh(side0_geometry, this.setMaterial('material_front', 0x38ff20), 1);
                ID.meshs.push(side0.id);
                side0.name = 'material_front';
                // this.setTexture(side0, this.getTextureUrl(side0.material.name), side0.material.name)
                const group0 = new THREE.Group();
                group0.add(side0, this.drills[0]);
                group0.position.set(0, 0, this.data.size.z / 2);

                const side1_geometry = new THREE.ExtrudeGeometry(this.shapes[1], extrudeSettings);
                ID.geometry.push(side1_geometry.id);
                const side1 = new THREE.InstancedMesh(side1_geometry, this.setMaterial('material_back', 0xff0000), 1);
                ID.meshs.push(side1.id);
                side1.name = 'material_back';
                // this.setTexture(side1, this.getTextureUrl(side1.material.name), side1.material.name)
                const group1 = new THREE.Group();
                group1.add(side1, this.drills[1]);
                group1.position.set(0, 0, -this.data.size.z / 2);
                /** END PLASZCZYZNA */

                /** KRAWEDZ */
                const side2_geometry = new THREE.ExtrudeGeometry(this.shapes[2], extrudeSettings);
                ID.geometry.push(side2_geometry.id);
                const side2 = new THREE.InstancedMesh(side2_geometry, this.setMaterial(/*(this.data.graining === 1 ? 'veneer_top' : 'veneer_right')*/'veneer_right', (this.data.graining === 1 ? 0x008dff : 0xfff705), new THREE.Vector2(1,8)), 1);
                ID.meshs.push(side2.id);
                side2.name = 'veneer_right';
                // this.setTexture(side2, this.getTextureUrl(side2.material.name), side2.material.name)
                const group2 = new THREE.Group();
                group2.add(side2, this.drills[2]);
                group2.rotation.x = Math.PI / 2;
                group2.position.set(0, -this.data.size.y / 2, 0);

                const side3_geometry = new THREE.ExtrudeGeometry(this.shapes[3], extrudeSettings);
                ID.geometry.push(side3_geometry.id);
                const side3 = new THREE.InstancedMesh(side3_geometry, this.setMaterial(/*(this.data.graining === 1 ? 'veneer_bottom' : 'veneer_left')*/'veneer_left', (this.data.graining === 1 ? 0x9b9b9b : 0x000000), new THREE.Vector2(1,8)), 1);
                ID.meshs.push(side3.id);
                side3.name = 'veneer_left';
                // this.setTexture(side3, this.getTextureUrl(side3.material.name), side3.material.name)
                const group3 = new THREE.Group();
                group3.add(side3, this.drills[3]);
                group3.rotation.x = Math.PI / 2;
                group3.position.set(0, this.data.size.y / 2, 0);

                const side4_geometry = new THREE.ExtrudeGeometry(this.shapes[4], extrudeSettings);
                ID.geometry.push(side4_geometry.id);
                const side4 = new THREE.InstancedMesh(side4_geometry, this.setMaterial(/*(this.data.graining === 1 ? 'veneer_right' : 'veneer_bottom')*/'veneer_bottom', (this.data.graining === 1 ? 0xfff705 : 0x9b9b9b), new THREE.Vector2(1,8)), 1);
                ID.meshs.push(side4.id);
                side4.name = 'veneer_bottom';
                // this.setTexture(side4, this.getTextureUrl(side4.material.name), side4.material.name)
                const group4 = new THREE.Group();
                group4.add(side4, this.drills[4]);
                group4.rotation.y = Math.PI / 2;
                group4.rotation.z = Math.PI / 2
                group4.position.set(-this.data.size.x / 2, 0, 0);

                const side5_geometry = new THREE.ExtrudeGeometry(this.shapes[5], extrudeSettings);
                ID.geometry.push(side5_geometry.id);
                const side5 = new THREE.InstancedMesh(side5_geometry, this.setMaterial(/*(this.data.graining === 1 ? 'veneer_left' : 'veneer_top')*/'veneer_top', (this.data.graining === 1 ? 0x000000 : 0x008dff), new THREE.Vector2(1,8)), 1);
                ID.meshs.push(side5.id);
                side5.name = 'veneer_top';
                // this.setTexture(side5, this.getTextureUrl(side5.material.name), side5.material.name)
                const group5 = new THREE.Group();
                group5.add(side5, this.drills[5]);
                group5.rotation.y = Math.PI / 2;
                group5.rotation.z = Math.PI / 2;
                group5.position.set(this.data.size.x / 2, 0, 0);
                /** END KRAWEDZ */

                side0.castShadow = side1.castShadow = side2.castShadow = side3.castShadow = side4.castShadow = side5.castShadow = true;
                side0.receiveShadow = side1.receiveShadow = side2.receiveShadow = side3.receiveShadow = side4.receiveShadow = side5.receiveShadow = true;
                // side0.material.map.anisotropy = side1.material.map.anisotropy = side2.material.map.anisotropy = side3.material.map.anisotropy = side4.material.map.anisotropy = side5.material.map.anisotropy = renderer.capabilities.getMaxAnisotropy();
                edges.add(group0, group1, group2, group3, group4, group5);
                // edges.add(form);


                // edges = new THREE.Mesh(
                //     new THREE.BoxGeometry(this.data.size.x, this.data.size.y, this.data.size.z),
                //     [
                //         this.setMaterial(/*(this.data.graining === 1 ? 'veneer_top' : 'veneer_right')*/'veneer_right', (this.data.graining === 1 ? '#008dff' : 'yellow')),
                //         this.setMaterial(/*(this.data.graining === 1 ? 'veneer_bottom' : 'veneer_left')*/'veneer_left', (this.data.graining === 1 ? '#9b9b9b' : 'black')),
                //         this.setMaterial(/*(this.data.graining === 1 ? 'veneer_left' : 'veneer_top')*/'veneer_top', (this.data.graining === 1 ? 'black' : '#008dff')),
                //         this.setMaterial(/*(this.data.graining === 1 ? 'veneer_right' : 'veneer_bottom')*/'veneer_bottom', (this.data.graining === 1 ? 'yellow' : '#9b9b9b')),
                //         this.setMaterial('material_front', '#38ff20'),
                //         this.setMaterial('material_back', 'red')
                //     ]
                // )
            }
        }
        try {
            if (this.data.direction !== undefined) {
                if (this.data.direction.includes('f')) {//[f]ront
                    if (this.data.size !== undefined && this.data.size.z !== undefined) {
                        edges.position.z += this.data.size.z / 2;
                    }
                }
                if (this.data.direction.includes('k')) {//bac[k]
                    if (this.data.shapes !== undefined && this.data.size.z !== undefined) {
                        edges.position.z -= this.data.size.z;
                    }
                    if (this.data.size !== undefined && this.data.size.z !== undefined) {
                        edges.position.z -= this.data.size.z / 2;
                    }
                }
                if (this.data.direction.includes('r')) {//[r]ight
                    edges.position.x -= this.data.size.x / 2;
                }
                if (this.data.direction.includes('l')) {//[l]eft
                    edges.position.x += this.data.size.x / 2;
                }
                if (this.data.direction.includes('t')) {//[t]op
                    edges.position.y -= this.data.size.y / 2;
                }
                if (this.data.direction.includes('b')) {//[b]ottom
                    edges.position.y += this.data.size.y / 2;
                }
                if (this.data.direction.includes('p')) {//[p]olygon
                    const i = parseInt(this.data.direction.substring(this.data.direction.indexOf('*') + 1, this.data.direction.lastIndexOf('*')));
                    edges.position.x += this.data.shapes[i].x * -1;
                    edges.position.y += this.data.shapes[i].y * -1;
                }
            } else {
                if (this.data.size !== undefined && this.data.size.z !== undefined) {
                    edges.position.set(this.data.size.x / 2, this.data.size.y / 2, this.data.size.z / 2);
                }
            }
        } catch (e) {
            console.debug(e);
        }

        grupa.add(edges);
        grupa.rotation.x = this.data.rotation.x * (Math.PI / 180);
        grupa.rotation.y = this.data.rotation.y * (Math.PI / 180);
        grupa.rotation.z = this.data.rotation.z * (Math.PI / 180);
        cube.position.set(this.data.position.x, this.data.position.y, this.data.position.z);
        cube.add(grupa);
        cube.add(accessories);
        cube.updateMatrix();

        // cube = this.formGroup(cube, this.data);


        let corpsStorage = cube;
        let add = true;
        if (this.data.group && this.data.cabinetName) {
            if (Scene.scene.getObjectById(this.data.cabinetID) && Scene.scene.getObjectByName(this.data.group.key)) {
                corpsStorage = Scene.scene.getObjectByName(this.data.group.key) as THREE.Group;
                add = false;
            } else {
                corpsStorage = new THREE.Group();
                corpsStorage.name = this.data.group.key;
            }
            corpsStorage.add(cube);
        }
        if (this.data.action || (this.data.group && this.data.group.data.actions)) {
            this.setAction(corpsStorage, (this.data.action || this.data.group.data.actions))
        }

        if (Env.objectsState) {
            if (Env.objectsState[corpsStorage.name]) {
                corpsStorage.rotation.set(Env.objectsState[corpsStorage.name].x, Env.objectsState[corpsStorage.name].y, Env.objectsState[corpsStorage.name].z);
            }
        }

        if (this.data && this.data.group) {
            try {
                let dataPosition = this.data.group.data['3d_positions'];
                let position = new THREE.Vector3;
                Object.keys(dataPosition[0]).map(key => position[key] = dataPosition[0][key] * Env.size_units);
                corpsStorage.position.copy(position);
            } catch (e) {
            }
        }
        return add ? corpsStorage : add;
    }

    textureCheckRepeat(name, repeat) {
        if(!name.includes('material') && this.getTextureUrl(name) === `${Env.base_url}static/corps/obrzeze_brak.jpg`) {
            repeat = new THREE.Vector2(2,2);
        }
        return repeat
    }

    setMaterial(name = '', color = 0xffffff, repeat = new THREE.Vector2(1,1)) {
        repeat = this.textureCheckRepeat(name, repeat);
        let material = Env.materialsLibrary.find(
            material => material.userData.texture_id === this.getTextureId(name)
                && material.userData.url === this.getTextureUrl(name)
                && material.userData.graining === this.data.graining
                && material.userData.color === color
        );
        if (!material) {
            // material = new THREE.MeshStandardMaterial({
            material = new THREE.MeshStandardMaterial({
                // name: `${this.data.key}_${name}`,
                // displacementScale: 0,
                side: THREE.DoubleSide,
                fog: false,
                // reflectivity: 1,
                // roughness: 1,
                // metalness: .1,
                // clearcoat: 0,
                // clearcoatRoughness: 1,
                // color: 0xffffff,
                // envMap: Lights.PMREMGenerator,
                // envMapIntensity: Lights.envMapIntensity,
                userData: {
                    color: color,
                    texture_id: this.getTextureId(name),
                    url: this.getTextureUrl(name),
                    graining: this.data.graining
                }
            });
            try {
                material.map = this.setTexture(name, '', repeat);
                material.map.anisotropy = Renderer.renderer.capabilities.getMaxAnisotropy();
                // material.envMap = self.envMap;
                // material.envMapIntensity = self.envMapIntensity;
            } finally {
            }
            Env.materialsLibrary.push(material);
            ID.materials.push(material.id);
        }
        return material;
    }

    setTexture(name = '', url = '', repeat = new THREE.Vector2(0,0)) {
        url = url ? url : this.getTextureUrl(name);
        const rotation = this.data.graining && this.data.graining === 1 ? 0 : Math.PI / 2;
        if (Env.textures.find(texture => texture.userData.url === url && texture.userData.rotation === rotation && texture.userData.repeat.x === repeat.x && texture.userData.repeat.y === repeat.y)) {
            return Env.textures.find(texture => texture.userData.url === url && texture.userData.rotation === rotation && texture.userData.repeat.x === repeat.x && texture.userData.repeat.y === repeat.y);
        } else {
            let image, texture;
            try {
                if (THREE.Cache.get(url) === undefined) throw 'brak tekstury';
                image = THREE.Cache.get(url);
                texture = new THREE.CanvasTexture(image);
            } catch (e) {
                image = THREE.Cache.get(`${Env.base_url}static/corps/default.png`);
                texture = new THREE.CanvasTexture(image);
            }
            if(!(name && name.includes('veneer'))) {
                texture.rotation = rotation;
            }
            texture.offset = new THREE.Vector2(.5,.5);
            texture.depthPacking = THREE.RGBADepthPacking;
            texture.mapping = THREE.UVMapping;
            texture.repeat = repeat;
            texture.wrapS = texture.wrapT = THREE.MirroredRepeatWrapping;// THREE.RepeatWrapping;//THREE.RepeatWrapping;
            texture.anisotropy = Renderer.renderer.capabilities.getMaxAnisotropy();
            texture.magFilter = THREE.NearestFilter;
            texture.minFilter = THREE.LinearFilter;
            texture.premultiplyAlpha = true;
            texture.crossOrigin = true;
            // texture.colorSpace = THREE.SRGBColorSpace;
            texture.colorSpace = THREE.LinearSRGBColorSpace;
            texture.flipY = false;
            texture.needsUpdate = true;
            texture.updateMatrix();
            texture.userData = {
                url: url,
                repeat: repeat,
                rotation: rotation
            };
            Env.textures.push(texture);
            ID.textures.push(texture.id)
            return texture;
        }
    }

    getTextureId(name = '') {
        if (name.includes('material')) {
            return this.data.material_id;
        } else if (name.includes('veneer')) {
            switch (true) {
                case name.includes('top'):
                    return this.data.veneers_data[1].id;
                case name.includes('bottom'):
                    return this.data.veneers_data[0].id;
                case name.includes('left'):
                    return this.data.veneers_data[2].id;
                case name.includes('right'):
                    return this.data.veneers_data[3].id;
                case name.includes('#') && parseInt(name.substring(name.indexOf('#') + 1)) <= this.data.veneers_data.length - 1:
                    return this.data.veneers_data[name.substring(name.indexOf('#') + 1)].id;
                default:
                    return undefined;
            }
        } else {
            return undefined;
        }
    }

    getTextureUrl(name) {
        const texture_id = this.getTextureId(name);
        switch (true) {
            case !texture_id:
                return `${Env.base_url}static/corps/obrzeze_brak.jpg`;
            case name.includes('material') && parseInt(texture_id) === parseInt(this.data.material_id):
                return parseInt(this.data.materials.image_exist) ? this.data.materials.image_big : `${Env.base_url}static/corps/obrzeze_brak.jpg`;
            case name.includes('veneer') && parseInt(texture_id) === parseInt(this.data.veneers.id):
                return parseInt(this.data.veneers.image_exist) ? this.data.veneers.image_big : `${Env.base_url}static/corps/obrzeze_brak.jpg`;
            default:
                return `${Env.base_url}static/corps/obrzeze_brak.jpg`;
        }
    }

    setAction(object, action) {
        for (const event in action) {
            if (!object.userData.action) {
                object.userData.action = {};
            }
            const actionName = action[event].ejecting
                ? 'ejecting'
                : (action[event].opening
                    ? 'opening'
                    : 'custom');
            if (!object.userData.action[event]) {
                object.userData.action[event] = {
                    property: action[event].ejecting
                        ? 'position'
                        : (action[event].opening
                            ? 'rotation'
                            : action[event].property),
                    axis: action[event][actionName].axis ?? undefined,
                    value: (function () {
                        const angle = action[event][actionName].angle
                            ? action[event][actionName].angle * (Math.PI / 180)
                            : 0;
                        const depth = function () {
                            if (action[event][actionName].value) {
                                return action[event][actionName].value * Env.size_units;
                            } else if (action[event][actionName].percent) {
                                return ((action[event][actionName].percent / 100) *
                                    new THREE.Box3().setFromObject(object).getSize(new THREE.Vector3).z
                                );
                            } else {
                                return 0;
                            }
                        }
                        const value = function () {
                            switch (actionName) {
                                case 'opening':
                                    return angle;
                                case 'ejecting':
                                    return depth();
                                case 'custom':
                                    return depth();
                                default:
                                    return 0;
                            }
                        }
                        const startValue = (function () {
                            switch (actionName) {
                                case 'opening':
                                    return 0;
                                case 'ejecting':
                                    return object.position[action[event][actionName].axis];
                                case 'custom':
                                    return object.position[action[event][actionName].axis];
                                default:
                                    return 0;
                            }
                        })()
                        let targetValue;
                        return function () {
                            if (!targetValue || targetValue === startValue) {
                                targetValue = value();
                            } else {
                                targetValue = startValue;
                            }
                            return targetValue;
                        }
                    })(),
                    speed: action[event][actionName].speed
                        ? action[event][actionName].speed * 1000
                        : 0,
                    delay: action[event][actionName].delay
                        ? action[event][actionName].delay * 1000
                        : 0
                }
                addEventListener(object.uuid, function (e) {
                    if (object.userData.action[e.detail.event]) {
                        tween(
                            object[object.userData.action[e.detail.event].property],
                            object.userData.action[e.detail.event].axis,
                            object.userData.action[e.detail.event].value(),
                            object.userData.action[e.detail.event].speed,
                            object.userData.action[e.detail.event].delay
                        );
                    }
                });
            }
        }
    }

    accessories() {
        if (this.data.accessories.length > 0) {
            for (const accessories of this.data.accessories) {
                for (const index in accessories.position) {
                    try {
                        const object = THREE.Cache.get(accessories.url).clone();
                        let size = object.localToWorld(new THREE.Box3().setFromObject(object)).getSize(new THREE.Vector3);
                        //rotation
                        if (accessories.rotate) {
                            if (accessories.rotate.length > 0) {
                                let i = !(accessories.rotate.length > 1) ? 0 : 1;
                                object.rotation.set(accessories.rotate[i].x * (Math.PI / 180), accessories.rotate[i].y * (Math.PI / 180), accessories.rotate[i].z * (Math.PI / 180));
                            }
                        }
                        object.updateMatrix();
                        //scale
                        if ('scale' in accessories) {
                            accessories.scale /= 10;
                            object.scale.set(accessories.scale, accessories.scale, accessories.scale);
                        } else if ('szerokosc' in accessories && 'dlugosc' in accessories && 'grubosc' in accessories) {
                            object.scale.set((accessories.szerokosc * Env.size_units / size.x), (accessories.dlugosc * Env.size_units / size.y), (accessories.grubosc * Env.size_units / size.z));
                        } else {
                            let scale;
                            if ('szerokosc' in accessories) {
                                scale = accessories.szerokosc * Env.size_units / size.x;
                            }
                            if ('dlugosc' in accessories) {
                                scale = accessories.dlugosc * Env.size_units / size.y;
                            }
                            if ('grubosc' in accessories) {
                                scale = accessories.grubosc * Env.size_units / size.z;
                            }
                            object.scale.set(scale, scale, scale);
                        }
                        object.name = accessories.url + `#${index}`;
                        const grupa = Scene.scene.getObjectById(this.grupaID) as THREE.Object3D;
                        (Scene.scene.getObjectById(this.accessoriesID) as THREE.Object3D).position.set(grupa.position.x, grupa.position.y, grupa.position.z);
                        if ((Scene.scene.getObjectById(this.accessoriesID) as THREE.Object3D).children.find(element => element.name === object.name) === undefined) {
                            ( Scene.scene.getObjectById(this.accessoriesID) as THREE.Object3D).add(object);
                        }
                        Scene.scene.updateMatrix();
                        object.position.set(accessories.position[index].x * Env.size_units, accessories.position[index].y * Env.size_units, accessories.position[index].z * Env.size_units);
                        ID.accessories.push(object.id);
                        // return object.id;
                    } catch (e) {
                        console.debug(e);
                    }
                }
            }
        }
    }

    /**
     * @param {*} cabinetName nazwa szafki
     * @param {*} data cała tablica danych
     * @param {*} index nazwa formatki
     * @param {*} i indeks pozycji danej formatki
     * @returns 
     */
    static prepareJSON(cabinetName, data, index, i, cabinetID) {
        if (data && typeof data === 'object' && index in data.panels) {
            const key = data.panels[index]['3d_positions'].length > 1 ? `${index}_#${i}` : index;
            return {
                cabinetID: cabinetID,
                key: key,
                shapes: (function () {
                    if ('polygon' in data.panels[index]) {
                        const array: any[] = [];
                        for (let pIndex in data.panels[index].polygon) {
                            array.push(
                                new THREE.Vector2(
                                    parseFloat(data.panels[index].polygon[pIndex].x) * Env.size_units,
                                    parseFloat(data.panels[index].polygon[pIndex].y) * Env.size_units
                                )
                            );
                        }
                        return array;
                    } else {
                        return undefined;
                    }
                })(),
                size: (function () {
                    let x = 0, y = 0, z = 0;
                    if (data.panels[index].width) {
                        x = parseFloat(data.panels[index].width) * Env.size_units;
                    }
                    if (data.panels[index].width) {
                        y = parseFloat(data.panels[index].length) * Env.size_units;
                    }
                    if (data.panels[index].thickness) {
                        z = parseFloat(data.panels[index].thickness) * Env.size_units;
                    } else if (data.panels[index].grubosc) {
                        z = parseFloat(data.panels[index].grubosc) * Env.size_units;
                    } else if (data.materials[data.panels[index].material].data.thickness) {
                        z = parseFloat(data.materials[data.panels[index].material].data.thickness) * Env.size_units;
                    } else if (data.materials[data.panels[index].material].data.grubosc) {
                        z = parseFloat(data.materials[data.panels[index].material].data.grubosc) * Env.size_units;
                    }
                    if (data.panels[index].double_format && data.panels[index].double_format === 1) {
                        z *= 2;
                    }
                    return { x: x, y: y, z: z };
                })(),
                rotation: {
                    x: data.panels[index]['3d_rotate'] !== undefined ? data.panels[index]['3d_rotate'].x : 0,
                    y: data.panels[index]['3d_rotate'] !== undefined ? data.panels[index]['3d_rotate'].y : 0,
                    z: data.panels[index]['3d_rotate'] !== undefined ? data.panels[index]['3d_rotate'].z : 0
                },
                position: {
                    x: parseFloat(data.panels[index]['3d_positions'][i].x) * Env.size_units,
                    y: parseFloat(data.panels[index]['3d_positions'][i].y) * Env.size_units,
                    z: parseFloat(data.panels[index]['3d_positions'][i].z) * Env.size_units
                },
                group: 'grupa' in data.panels[index]
                    ? {
                        key: data.panels[index].grupa,
                        data: data.grupy[data.panels[index].grupa]
                    }
                    : undefined,
                materials: data.materials[data.panels[index].material].data,
                material_id: (function () {
                    if (!data.panels[index].material_id) {
                        return data.materials[data.panels[index].material].data.id;
                    } else {
                        return data.panels[index].material_id;
                    }
                })(),
                veneers: data.veneers[data.panels[index].material] !== undefined
                    ? data.veneers[data.panels[index].material].data
                    : undefined,
                veneers_data: (function () {
                    const veneers_data = [];
                    if (data.panels[index].veneers_data) {
                        return data.panels[index].veneers_data;
                    } else {
                        for (const i in data.panels[index].veneers) {
                            if (data.panels[index].veneers[i]) {
                                veneers_data[i] = data.veneers[data.panels[index].material].data;
                            } else {
                                veneers_data[i] = { veneer: 0 }
                            }
                        }
                    }
                    return veneers_data;
                })(),
                drill: (function () {
                    if (data.panels && data.panels[index] && data.panels[index].cnc && data.panels[index].cnc.length) {
                        return data.panels[index].cnc;
                    } else {
                        return undefined;
                    }
                })(),
                graining: 'grain' in data.panels[index]
                    ? data.panels[index].grain
                    : undefined,
                index: i,
                // desk: data.panels[index],
                direction: data.panels[index]['3d_point_start'] ?? undefined,
                action: data.panels[index].actions ?? undefined,
                cabinetName: cabinetName,
                cnc: data.panels[index].cnc,
                accessories: (function () {
                    const accessories: any[] = [];
                    for (const index in data['3d_model']) {
                        if (data['3d_model'][index].desk === key) {
                            accessories.push(data['3d_model'][index])
                        }
                    }
                    return accessories;
                })()
            };
        } else {
            return {};
        }
    }
}
